import React from 'react';
import { getImageUrl } from '../../../utils/imageUtils';

const AudioTracksSection = ({ audioTracks }) => (
    <div className="rounded-2xl bg-white border border-secondary-200 shadow-soft p-5">
        <div className="flex items-center justify-between gap-3 mb-3">
            <div className="text-sm font-semibold text-secondary-900">Музыка</div>
            <div className="text-xs text-secondary-500">{audioTracks.length} / 3</div>
        </div>
        <div className="space-y-3">
            {audioTracks.map((t, idx) => (
                <div key={t.id} className="rounded-xl border border-secondary-200 bg-secondary-50 p-3">
                    <div className="flex items-start justify-between gap-2">
                        <div className="min-w-0">
                            <div className="text-xs text-secondary-500">Трек {idx + 1}</div>
                            <div className="text-sm text-secondary-900 truncate">
                                {t.original_name || 'MP3'}
                            </div>
                        </div>
                    </div>
                    <div className="mt-2">
                        <audio controls preload="none" className="w-full">
                            <source src={getImageUrl(t.audio_url)} type="audio/mpeg" />
                        </audio>
                    </div>
                </div>
            ))}
        </div>
    </div>
);

export default AudioTracksSection;
